import React from 'react';
import { Pencil } from 'phosphor-react';

interface SettingsFieldProps {
  label: string;
  value?: string;
  icon?: React.FC<React.SVGProps<SVGSVGElement> & { className?: string }>;
  editable?: boolean;
  onEdit?: () => void;
  children?: React.ReactNode;
}

export default function SettingsField({
  label,
  value,
  icon: Icon,
  editable = false,
  onEdit,
  children,
}: SettingsFieldProps) {
  return (
    <div className="bg-white dark:bg-gray-800 rounded-2xl p-4 shadow-soft dark:shadow-none dark:border dark:border-gray-700">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-3 flex-1 min-w-0">
          {Icon && (
            <div className="w-9 h-9 rounded-xl bg-blush-50 dark:bg-blush-900/20 flex items-center justify-center shrink-0">
              <Icon className="w-4 h-4 text-blush-500" />
            </div>
          )}
          <div className="min-w-0 flex-1">
            <p className="text-xs text-nude-400 dark:text-gray-500 font-medium uppercase tracking-wider">
              {label}
            </p>
            {!children && (
              <p className="text-sm text-gray-800 dark:text-gray-100 font-medium mt-0.5 truncate">
                {value}
              </p>
            )}
          </div>
        </div>

        {editable && onEdit && (
          <button
            onClick={onEdit}
            className="p-2 text-nude-400 dark:text-gray-400 hover:text-blush-500 hover:bg-blush-50 dark:hover:bg-gray-700 rounded-xl transition-colors shrink-0"
            aria-label={`Editar ${label}`}
          >
            <Pencil className="w-4 h-4" />
          </button>
        )}
      </div>

      {children && <div className="mt-2">{children}</div>}
    </div>
  );
}
